// Wolfhound Feature Tab Section
// Replaces inline onclick handlers with proper event delegation,
// adds full ARIA (tablist/tab/tabpanel) and arrow-key keyboard navigation.

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.wh-tab-section').forEach(function (section) {
    var tablist = section.querySelector('.wh-tab-list');
    var buttons = Array.from(section.querySelectorAll('.wh-tab-btn'));
    var panels = Array.from(section.querySelectorAll('.wh-tab-panel'));

    if (!tablist || !buttons.length || !panels.length) return;

    function activateTab(index) {
      buttons.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-selected', String(active));
        btn.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('active', active);
        panel.setAttribute('aria-hidden', String(!active));
      });
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        activateTab(index);
        btn.focus();
      });

      btn.addEventListener('keydown', function (e) {
        var newIndex = index;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          newIndex = (index + 1) % buttons.length;
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = (index - 1 + buttons.length) % buttons.length;
        } else if (e.key === 'Home') {
          e.preventDefault();
          newIndex = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          newIndex = buttons.length - 1;
        } else {
          return;
        }
        activateTab(newIndex);
        buttons[newIndex].focus();
      });
    });
  });
});
